<template>
  <div class="message">
    <Modal
      v-model="xiaoxi"
      width="700px"
      class-name="vertical-center-modal"
      @on-cancel="cancel"
    >
      <div class="chat-box">
        <header>
          <div class="left"></div>
          <div class="middle">{{ list_mass.name + "-" + list_mass.perName }}</div>
          <div class="right"></div>
        </header>
        <div class="msg-box" ref="msg-box">
          <div
            v-for="(i, index) in list"
            :key="index"
            class="msg"
            :style="i.userId == list_mass.userId ? 'flex-direction:row-reverse' : ''"
          >
            <div class="user-head">
              <img
                v-if="i.userId !== list_mass.userId"
                :src="$global.imgUrl + list_mass.perLogo"
                alt=""
              />
              <img v-else-if="myImg" :src="$global.imgUrl + myImg" alt="" />
              <img v-else src="../../../../public/mobileImg/service.png" alt="" />
            </div>
            <div class="user-msg">
              <span
                :style="i.userId == list_mass.userId ? ' float: right;' : ''"
                :class="i.userId == list_mass.userId ? 'right' : 'left'"
                >{{ i.content }}</span
              >
            </div>
          </div>
        </div>
        <div class="input-box">
          <input
            type="text"
            ref="sendMsg"
            v-model="contentText"
            @keyup.enter="sendText()"
          />
          <div class="btn" :class="{ ['btn-active']: contentText }" @click="sendText()">
            发送
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import card from "@/components/cards";
export default {
  name: "message",
  props: {
    list_mass: {
      type: Object,
      required: false,
    },
    xiaoxi: Boolean,
  },
  // props: ["xiaoxi", "list_mass"],
  watch: {
    list_mass(val) {
      this.list_mass = val;

      // if (this.list_mass.groupId) {
      //   this.getChatId();
      // } else {
      //   this.getHistory();
      // }
      // this.initWebSocket();
    },
  },
  data() {
    return {
      // titles: "李鹏与你对话",
      // value17: "",
      //name=张霸天&perName=张碎天的book&perId=1297783010043576320&groupId=1447865544660357120&userId=1446352177927950336&perLogo=group1%2FM00%2F00%2F3F%2FrBF-Yl_8FS6AShtQAAAkHKUVYIY693.jpg\

      // xiaoxi: window.localStorage.getItem("xiaoxi"),
      // list_mass: JSON.parse(localStorage.getItem("list_mass")),
      msgType: 0,
      reciveId: 2,

      groupId: "",
      // sendText: '',
      groupsId: this.list_mass.groupId, // 组ID
      myId: JSON.parse(sessionStorage.getItem("userInfo")).user.id, // 我的ID
      ws: null,
      myImg: "",
      count: 0,
      userId: null, //当前用户ID
      list: [], //聊天记录的数组
      contentText: "", //input输入的值
      form1: {
        groupId: "",
        pageNo: 1,
        pageSize: 100,
      },
      form2: {
        perId: this.list_mass.perId,
        reciveId: this.list_mass.userId,
        sendId: JSON.parse(sessionStorage.getItem("userInfo")).user.id,
      },
    };
  },
  mounted() {
    if (this.list_mass.groupId == "" || this.list_mass.groupId == undefined) {
      this.getChatId();
      var vm = this;
      setTimeout(function () {
        vm.initWebSocket();
      }, 2000);
    } else {
      this.getHistory();
      this.initWebSocket();
    }
  },

  components: {
    card,
  },
  methods: {
    //获取聊天记录
    getHistory() {
      if (this.list_mass.groupId) {
        this.form1.groupId = this.list_mass.groupId;
      } else {
        this.form1.groupId = this.groupsId;
      }
      this.$apis.chat
        .getChatContent(this.form1)
        .then((result) => {
          this.list = result.data.list
            .map((item) => {
              return {
                content: item.sendText,
                userId: item.reciveId,
              };
            })
            .reverse();
          setTimeout(() => {
            this.scrollBottm();
          }, 500);
        })
        .catch((err) => {});
    },
    //获取聊天组id
    getChatId() {
      this.$apis.chat
        .getChatId(this.form2)
        .then((result) => {
          this.groupsId = result.data;
          this.getHistory();
        })
        .catch((err) => {});
    },
    //滚动条到底部
    scrollBottm() {
      var el = this.$refs["msg-box"];
      el.scrollTop = el.scrollHeight;
    },
    //发送聊天信息
    sendText() {
      var _this = this;
      _this.$refs["sendMsg"].focus();
      if (!_this.contentText) {
        return;
      }
      var params = {
        groupId: _this.list_mass.groupId ? _this.list_mass.groupId : _this.groupsId,
        msgType: 1,
        reciveId: _this.list_mass.userId,
        sendText: _this.contentText,
        sendId: this.$store.state.userId,
      };

      _this.ws.send(JSON.stringify(params)); //调用WebSocket send()发送信息的方法
      _this.contentText = "";
      setTimeout(() => {
        _this.scrollBottm();
      }, 500);
    },
    //进入页面创建websocket连接
    initWebSocket() {
      var _this = this;
      //判断页面有没有存在websocket连接
      if (window.WebSocket) {
        // 192.168.0.115 是我本地IP地址 此处的 :8181 端口号 要与后端配置的一致
        
        var listurl = ""
        if(location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1){
            listurl = "wss://testchat.cnknowledge.com/zw-edit-card/websocket/"
        }else if(location.host.indexOf("yucard.") != -1){
            listurl = "wss://yuchat.cnknowledge.com/zw-edit-card/websocket/"
        }else if(location.host.indexOf("card.") != -1){
            listurl = "wss://chat.cnknowledge.com/zw-edit-card/websocket/"
        }

        var ws = new WebSocket(
          `${listurl}${_this.groupsId + "_" + _this.list_mass.userId}`
        );
        console.log(ws)
        _this.ws = ws;
        ws.onopen = function (e) {
          console.log("服务器连接成功");
        };
        ws.onclose = function (e) {
          console.log("服务器连接关闭");
        };
        ws.onerror = function (error) {
          console.log("服务器连接出错");
          console.error('WebSocket 错误:', error);
        };
        ws.onmessage = function (e) {
          //接收服务器返回的数据
          var resData = JSON.parse(e.data);

          if (resData.funName == "userCount") {
            _this.count = resData.users;
            _this.list = resData.chat;
          } else {
            _this.list = [
              ..._this.list,
              { userId: resData.reciveId, content: resData.sendText },
            ];
          }
          setTimeout(() => {
            _this.scrollBottm();
          }, 500);
        };
      }
    },
    cancel() {
      this.$emit("modalCancel", this.xiaoxi);
      this.ws.close();
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
/deep/ .v-transfer-dom {
  height: 0px;
}
/deep/ .ivu-modal-body {
  height: 600px;
  padding: 0px !important;
}
/deep/.ivu-modal-footer {
  display: none;
}
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
.chat-box {
  margin: 0 auto;
  background: #fafafa;
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 700px;
  header {
    position: fixed;
    width: 100%;
    height: 4rem;
    max-width: 700px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #333333;
    font-size: 1rem;
    .left {
      padding-left: 10px;
      width: 50px;
    }
    .middle {
      width: 300px;
      text-align: center;
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #111111;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .right {
      width: 50px;
    }
  }
  .msg-box {
    position: absolute;
    height: calc(100% - 7.5rem);
    width: 100%;
    margin-top: 4rem;
    overflow-y: scroll;
    background: #f6f6f6;
    .msg {
      width: 95%;
      min-height: 2.5rem;
      margin: 1rem 0.5rem;
      position: relative;
      display: flex;
      justify-content: flex-start !important;
      .user-head {
        min-width: 2.5rem;
        width: 20%;
        width: 2.5rem;
        height: 2.5rem;
        background: #f1f1f1;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        align-items: center;
        margin: auto 8px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        // position: absolute;
      }
      .user-msg {
        width: 80%;
        // position: absolute;
        word-break: break-all;
        position: relative;
        z-index: 5;
        .title {
          font-size: 0.1rem;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
        }
        span {
          display: inline-block;
          padding: 0.5rem 0.7rem;
          border-radius: 0.5rem;
          margin-top: 0.2rem;
          font-size: 0.88rem;
        }
        .left {
          background: white;
          animation: toLeft 0.5s ease both 1;
        }
        .right {
          background: #53a8ff;
          color: white;
          animation: toright 0.5s ease both 1;
        }
        @keyframes toLeft {
          0% {
            opacity: 0;
            transform: translateX(-10px);
          }
          100% {
            opacity: 1;
            transform: translateX(0px);
          }
        }
        @keyframes toright {
          0% {
            opacity: 0;
            transform: translateX(10px);
          }
          100% {
            opacity: 1;
            transform: translateX(0px);
          }
        }
      }
    }
  }
  .input-box {
    padding: 0 0.5rem;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3.5rem;
    background: #fafafa;
    box-shadow: 0 0 5px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    input {
      height: 2.3rem;
      display: inline-block;
      width: 100%;
      padding: 0.5rem;
      border: none;
      border-radius: 0.2rem;
      font-size: 0.88rem;
    }
    .btn {
      height: 2.3rem;
      min-width: 4rem;
      background: #e0e0e0;
      padding: 0.5rem;
      font-size: 0.88rem;
      color: white;
      text-align: center;
      border-radius: 0.2rem;
      margin-left: 0.5rem;
      transition: 0.5s;
      cursor: not-allowed;
    }
    .btn-active {
      background: #409eff;
      cursor: pointer;
    }
  }
}
</style>
